import { cn } from '@/lib/utils';

/** Inline chip showing a tool-call name + key args (e.g. ⚙️ find_programme { subject=maths }).
 *  `live` adds a pulsing dot while the tool is still running.
 *  `docCount` shows how many distinct source documents were found (displayed when results are ready). */
export default function ToolChip({ label, live, docCount }: { label: string; live?: boolean; docCount?: number }) {
  return (
    <div className={cn(
      "self-start inline-flex items-center gap-[6px] text-[12.5px] font-bold text-muted-foreground bg-secondary border border-border rounded-full px-[11px] py-[5px] opacity-[0.85]",
      live && "opacity-100"
    )}>
      <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[300px]">
        {label}
      </span>
      {docCount != null && (
        <span className="flex-shrink-0 text-[11px] font-bold text-muted-foreground opacity-75">
          {docCount}
        </span>
      )}
      {live && <span className="[animation:tcPulse_1s_ease-in-out_infinite]">·</span>}
    </div>
  );
}
